import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "card",
  "use": "card-usage",
  "viewBox": "0 0 48 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 30\" id=\"card\">\r\n  <path fill=\"#e4e6e6\" d=\"M3 0h42c1.7 0 3 1.3 3 3v24c0 1.7-1.3 3-3 3H3c-1.7 0-3-1.3-3-3V3c0-1.7 1.3-3 3-3z\" />\r\n  <path fill=\"#cfd0cf\" d=\"M19.5 18.5v3h24v-3h-24zm0 7.5h15v-3h-15v3zm-6-7.5h-6c-1.7 0-3 1.3-3 3V23c0 1.7 1.3 3 3 3h6c1.7 0 3-1.3 3-3v-1.5c0-1.7-1.3-3-3-3z\" />\r\n  <path fill=\"#fff\" d=\"M4.5 11.5h39V16h-39v-4.5z\" />\r\n  <path fill=\"#4e4e4e\" d=\"M0 4.5h48V9H0V4.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol